
import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ComboHero from './components/ComboHero';
import ComboOverview from './components/ComboOverview';
import ComboItinerary from './components/ComboItinerary';
import ComboGallery from './components/ComboGallery';
import ComboPricing from './components/ComboPricing';
import ComboFaq from './components/ComboFaq';
import ComboFinalCta from './components/ComboFinalCta';
import ComboWhatsAppButton from './components/ComboWhatsAppButton';

export default function TokyoNightComboPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Tokyo Night Combo Experience - Izakaya + Karaoke | Tokyo Local Concierge';
    document.documentElement.lang = 'en';

    const setMeta = (name: string, content: string, property?: boolean) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', 'Experience Tokyo Night in One Evening. Local izakaya + karaoke box combo with a friendly local guide. 4–5 hours, up to 4 guests, from ¥30,000. Book via WhatsApp.');
    setMeta('keywords', 'Tokyo night combo,izakaya karaoke,Tokyo nightlife,Airbnb guests Tokyo,local experience Tokyo,karaoke izakaya tour,Tokyo evening experience');
    setMeta('og:title', 'Tokyo Night Combo Experience - Izakaya + Karaoke | Tokyo Local Concierge', true);
    setMeta('og:description', 'Experience Tokyo Night in One Evening. Local izakaya + karaoke box combo with a friendly local guide. From ¥30,000.', true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', 'https://tokyolocalconcierge.com/tokyo-night-combo', true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', 'Tokyo Night Combo Experience - Izakaya + Karaoke');
    setMeta('twitter:description', 'Experience Tokyo Night in One Evening. Local izakaya + karaoke combo. From ¥30,000.');
    setMeta('geo.region', 'JP-13');
    setMeta('geo.placename', 'Tokyo');
    setMeta('geo.position', '35.6762;139.6503');
  }, []);

  return (
    <div className="min-h-screen bg-gray-950">
      <Navbar />
      <main>
        <ComboHero lang="en" />
        <ComboOverview lang="en" />
        <ComboItinerary lang="en" />
        <ComboGallery lang="en" />
        <ComboPricing lang="en" />
        <ComboFaq lang="en" />
        <ComboFinalCta lang="en" />
      </main>
      <Footer />
      <ComboWhatsAppButton lang="en" />
    </div>
  );
}
